// extracted by mini-css-extract-plugin
export default {"layout":"Admin_layout__6CsZh","main":"Admin_main__QZKKJ"};